export const $black_bg = '#001529'

export const $font_gray = '#999'

export const $border_color = '#e5e5e5'

export const $green = '#2fd6ce'

export const $gray3 = '#333'
